import React, { useCallback, useState } from 'react'
import Table from './Table'
import { useQueryClient } from '@tanstack/react-query'
import { initialPage } from 'keys/pagination'

const WrapTableContext = (props) => {
    const { setPage, searchVal, setSearchVal, page, sorting, queryKey, setRowOpen } = props
    const queryClient = useQueryClient()

    const [searchValue, setSearchValue] = useState(null)

    const handleSearch = useCallback(() => {
        setRowOpen?.(null)
        queryClient.invalidateQueries({ queryKey: queryKey })
        setPage(initialPage)
        setSearchVal(searchValue)
    }, [searchValue, queryKey])

    const commonState = {
        handleSearch,
        searchVal, setSearchVal,
        searchValue, setSearchValue,
        page,
        sorting,
        queryKey
    }

    return (
        <TableContext.Provider value={commonState}>
            <Table {...props} />
        </TableContext.Provider>
    )
}

export const TableContext = React.createContext()
export default WrapTableContext